import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import AppComponent from './AppComponent';
export const setupApp = (store, history) => {
  const rootElement = document.getElementsByClassName('page')[0];
  render( /*#__PURE__*/_jsx(AppComponent, {
    history: history,
    store: store
  }), rootElement);
};